// based on https://github.com/rxaviers/camelcase-keys-deep/blob/master/index.js

import camelcase from 'camelcase';
import mapObj from 'map-obj';

export function camelcaseKeysDeep(obj) {
  if (!obj) {
    return obj;
  }
  if (obj instanceof Date) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(element => {
      return camelcaseKeysDeep(element);
    });
  }
  if (typeof obj === 'object') {
    return mapObj(obj, (key, value) => {
      const newKey = camelcase(key);
      if (key !== newKey && newKey in obj) {
        throw new Error(
          `Camelcased key \`${newKey}\` would overwrite existing key of the given JSON object`,
        );
      }
      return [newKey, camelcaseKeysDeep(value)];
    });
  }

  return obj;
}
